import React from "react";

export default function Grid(props){

    const {
        columns = [],
        width = 300,
        height = 400,
        data = [],
        className = "",
        rowClass = () => { },
        header = false,
        row_key = "id"
    } = props;

    let _class = "ui-table-grid-wrap";

    const getValueFromRowByKey = (_row, _key) => {
        const keys = _key.split('.');
        let value = _row;

        for (const key of keys) {
            if (value && key in value) {
                value = value[key];
            } else {
                return undefined; // Return undefined if the key path is invalid
            }
        }

        return value;
    };

    const renderRow = (_row, _col, _ind) => {

        let _row_class = rowClass(_row);
        let _stl = {
            width: (_col?.width) ? _col.width + "px" : "auto",
            textAlign: (_col?.align) ? _col.align : "right",
        }
        if (!_row) {
            return (<td style={_stl} key={_ind}>&nbsp;</td>)
        }

        let _v = getValueFromRowByKey(_row, _col?.key);

        if (typeof _col.render === 'function') {
            _v = _col.render(_row[_col?.key], _row);
        }
        return <td className={_row_class} key={_col.key}><div className="td" style={_stl}>{_v}</div></td>
    }

    const renderCol = (_col) => {
        let _stl = {
            width: (_col?.width) ? _col.width + "px" : "auto",
            textAlign: (_col?.align) ? _col.align : "right",
        }
        return (<th style={_stl} key={_col.key}>{_col.title}</th>)
    }


    return(
        <>
        <div style={{ "width": width + "px", "height": (height) ? height + "px" : "auto" }} className={_class} >
            {(header && <div className="ui-table-header">{header}</div>)}
            <div className="ui-table-container grid" style={{ "height": (height) ? height + "px" : "auto"}}>
                <table style={{ "width": width + "px" }} tabIndex="0" className='ui-table'>
                    <thead>
                        <tr>
                            {columns.map(col => {
                                return renderCol(col);
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, ind) => {
                            let row = (ind >= 0 && ind < data.length) ? data[ind] : null;
                            return (
                                <tr className="ui-grid-row" key={item[row_key]} >
                                    {columns.map(col => {
                                        return renderRow(row, col, ind);
                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
        </>
    )
}